module.exports = __webpack_public_path__ + "static/media/favicon.9352d9fb.png";